import { QuickviewDataLoader } from "./quickview-data.js";

const DRAWER_ID = "quickview-drawer";

class QuickviewTriggerMobile extends HTMLElement {
  constructor() {
    super();
    this._loader = new QuickviewDataLoader();
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      const drawer = document.getElementById(DRAWER_ID);
      if (drawer) drawer._activeTrigger = this;

      this.querySelector("button").dispatchEvent(
        new CustomEvent("markup-modal:open", {
          detail: {
            target: DRAWER_ID,
            html: this._loader.getData(this.url, this.sectionId),
          },
          bubbles: true,
        }),
      );
    });

    this._handleDrawerClick = (e) => {
      const variantButton = e.target.closest("[data-variant-id]");
      if (!variantButton) return;

      const drawer = document.getElementById(DRAWER_ID);
      if (!drawer?._isOpen || drawer._activeTrigger !== this) return;

      this._addToCart(variantButton);
    };
    document.addEventListener("click", this._handleDrawerClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this._handleDrawerClick);
  }

  _addToCart(button) {
    window.addToCart(
      { id: button.dataset.variantId, quantity: 1 },
      {
        onAfterAdd: () => {
          document.addEventListener(
            "markup-modal:closed",
            () =>
              requestAnimationFrame(() =>
                document.dispatchEvent(new CustomEvent("mini-cart:open")),
              ),
            { once: true },
          );
          document.dispatchEvent(new CustomEvent("markup-modal:close"));
        },
        onError: (response) => {
          this._showError(
            response?.message || window.localeStrings.product.add_to_cart_error,
          );
        },
      },
    );
  }

  _showError(message) {
    const drawer = document.getElementById(DRAWER_ID);
    const quickview = drawer?.querySelector(".quickview");
    if (!quickview) return;

    const error = document.createElement("p");
    error.classList.add("quickview__error");
    error.innerHTML = message;
    quickview.append(error);

    setTimeout(() => error.remove(), 3000);
  }

  get url() {
    return this.getAttribute("url");
  }

  get sectionId() {
    return this.getAttribute("section-id") || "quickview";
  }
}

if (!customElements.get("quickview-trigger-mobile")) {
  customElements.define("quickview-trigger-mobile", QuickviewTriggerMobile);
}
